import TableGeneral from './TableGeneral'

export default TableGeneral
